<div class="pt-3">
    <!-- Filtros -->
    <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
        <div class="row search-area">
            <div class="col-12 col-lg-6">
                <mat-form-field appearance="outline">
                    <mat-label>Pesquisar</mat-label>
                    <input matInput type="text" formControlName="pesquisa" placeholder="Descrição, CFOP...">
                    <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
                        <mat-icon>search</mat-icon>
                    </button>
                </mat-form-field>
            </div>

            <div class="col-12 col-lg-6 filter-container">
                <button #filtrosMenuTrigger="matMenuTrigger" mat-stroked-button type="button"
                    class="btn-filter" [matMenuTriggerFor]="filtroMenu"
                    [matBadge]="qtdFiltrosAvancados" [matBadgeHidden]="qtdFiltrosAvancados === 0">
                    <mat-icon>filter_list</mat-icon>
                    Filtrar
                </button>

                <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
                    <div class="filter-menu-content" [formGroup]="model" (click)="$event.stopPropagation()">
                        <h6>Filtros</h6>
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Tipo</mat-label>
                            <mat-select formControlName="tipoOperacao">
                                @for (opt of tipoOperacaoOptions; track opt.value) {
                                <mat-option [value]="opt.value">{{opt.label}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <div class="filter-menu__actions">
                            <button mat-button class="btn-secondary" matMenuClose
                                (click)="filtrosMenuTrigger.closeMenu()">Cancelar</button>
                            <button mat-flat-button class="btn-primary" matMenuClose
                                (click)="aplicarFiltros()">Aplicar</button>
                        </div>
                    </div>
                </mat-menu>

                <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
                    <mat-icon>cleaning_services</mat-icon>
                    Limpar Filtros
                </button>
            </div>
        </div>
    </form>

    @if (_isSemNaturezaRegimeEmpresa && !_seedPendente) {
    <app-alert-card type="warning" class="d-block mb-3">
        Não há naturezas de operação para o regime {{ _descricaoRegimeTributarioEmpresa }} da empresa.
        <div alertActions>
            <button mat-button type="button" class="btn-section btn-spinner"
                [class.btn-loading]="_isCarregandoNaturezasPadrao" [disabled]="_isLoading"
                [attr.aria-label]="_isCarregandoNaturezasPadrao ? 'Carregando naturezas padrão' : 'Carregar naturezas padrão'"
                (click)="carregarNaturezasPadrao()">
                <mat-icon class="material-symbols-outlined">playlist_add</mat-icon>
                Carregar naturezas padrão
                @if (_isCarregandoNaturezasPadrao) { <mat-spinner diameter="20"></mat-spinner> }
            </button>
        </div>
    </app-alert-card>
    }

    @if (_isLoading && _dataSource.data.length === 0) {
    <app-loading-box-default-list></app-loading-box-default-list>
    } @else if (_dataSource.data.length > 0) {

    <!-- Tabela desktop -->
    <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>

        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef class="w-checkbox">
                <mat-checkbox (change)="$event ? toggleAllRows() : null"
                    [checked]="selection.hasValue() && isAllSelected()">
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row" class="w-checkbox">
                <mat-checkbox (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)">
                </mat-checkbox>
            </td>
        </ng-container>

        <ng-container matColumnDef="nome">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
            <td mat-cell *matCellDef="let element">{{ element.nome }}</td>
        </ng-container>

        <ng-container matColumnDef="tipo">
            <th mat-header-cell *matHeaderCellDef>Tipo</th>
            <td mat-cell *matCellDef="let element">
                <span class="status-badge"
                    [class.badge-azul]="element.idTipoOperacao === TipoOperacaoEnum.Entrada"
                    [class.badge-laranja]="element.idTipoOperacao === TipoOperacaoEnum.Saida">
                    {{tipoLabel[element.idTipoOperacao] || element.idTipoOperacao}}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="regime">
            <th mat-header-cell *matHeaderCellDef>Regime Tributário</th>
            <td mat-cell *matCellDef="let element">
                <span class="status-badge badge-cinza">
                    {{regimeLabel[element.idRegimeTributario] || element.idRegimeTributario}}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="cfop">
            <th mat-header-cell *matHeaderCellDef>CFOP</th>
            <td mat-cell *matCellDef="let element">
                <span class="status-badge badge-cinza">{{element.cfopPadrao | mask: '0.000' : { patterns: cfopMaskPatterns } }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="tributos">
            <th mat-header-cell *matHeaderCellDef>Tributos</th>
            <td mat-cell *matCellDef="let element">
                <div class="badges-row">
                    @for (tributo of element.tributos; track tributo) {
                    <span class="status-badge badge-azul">{{tributo}}</span>
                    }
                    @if (element.tributos.length === 0) {
                    <span class="text-secondary" style="font-size:0.82rem;">—</span>
                    }
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="reformaTributaria">
            <th mat-header-cell *matHeaderCellDef>Reforma Tributária</th>
            <td mat-cell *matCellDef="let element">
                @if (element.reformaTributariaConfigurada === null) {
                <span class="text-secondary" style="font-size:0.82rem;">—</span>
                } @else if (element.reformaTributariaConfigurada) {
                <span class="status-badge badge-verde">Configurada</span>
                } @else {
                <span class="status-badge badge-cinza">Pendente</span>
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="padrao">
            <th mat-header-cell *matHeaderCellDef>Padrão</th>
            <td mat-cell *matCellDef="let element">
                @for (tipo of element.tiposPadrao; track tipo) {
                <span class="status-badge badge-amarelo me-1">{{ nomeTipoPadrao(tipo) }}</span>
                } @empty {
                <span class="text-secondary" style="font-size:0.82rem;">-</span>
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element">
                @if (element.isAtivo) {
                <span class="status-badge badge-verde">Ativa</span>
                } @else {
                <span class="status-badge badge-vermelho">Inativa</span>
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
            <td mat-cell *matCellDef="let element" class="text-center w-actions">
                <button mat-icon-button [matMenuTriggerFor]="menuAcoes" aria-label="Ações">
                    <span class="material-symbols-outlined">more_horiz</span>
                </button>
                 <mat-menu #menuAcoes="matMenu">
                    <button mat-menu-item (click)="editarNatureza(element.idNaturezaOperacao)">
                        <span class="material-symbols-outlined">edit</span>
                        <span>Editar</span>
                    </button>
                    <button mat-menu-item (click)="duplicarNatureza(element.idNaturezaOperacao)">
                        <span class="material-symbols-outlined">content_copy</span>
                        <span>Duplicar</span>
                    </button>
                    <button mat-menu-item (click)="abrirTornarPadrao(element)" [disabled]="!element.isAtivo" [matTooltip]="!element.isAtivo ? 'Apenas naturezas ativas podem ser definidas como padrão.' : ''">
                        <span class="material-symbols-outlined">star</span>
                        <span>Definir como padrão</span>
                    </button>
                    <button mat-menu-item (click)="alternarStatus(element)" [disabled]="element.isAtivo && element.tiposPadrao.length > 0" [matTooltip]="(element.isAtivo && element.tiposPadrao.length > 0) ? 'Não é possível inativar uma natureza de operação padrão.' : ''">
                        <span class="material-symbols-outlined">{{ element.isAtivo ? 'toggle_off' : 'toggle_on' }}</span>
                        <span>{{ element.isAtivo ? 'Inativar' : 'Ativar' }}</span>
                    </button>
                    <button mat-menu-item (click)="confirmarExclusao(element)" [disabled]="element.tiposPadrao.length > 0" [matTooltip]="element.tiposPadrao.length > 0 ? 'Não é possível excluir uma natureza de operação padrão.' : ''">
                        <span class="material-symbols-outlined">delete</span>
                        <span>Excluir</span>
                    </button>
                </mat-menu>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>
    </table>

    <!-- Cards mobile -->
    <div class="mobile-view">
        @for (item of _dataSource.data; track item.idNaturezaOperacao) {
        <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(item)">
            <div class="card-header-mobile d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center gap-2">
                    <mat-checkbox (change)="$event ? selection.toggle(item) : null"
                        [checked]="selection.isSelected(item)">
                    </mat-checkbox>
                    <span class="text-bold">{{item.nome}}</span>
                </div>
                <button mat-icon-button [matMenuTriggerFor]="menuMob">
                    <span class="material-symbols-outlined">more_horiz</span>
                </button>
                <mat-menu #menuMob="matMenu">
                    <button mat-menu-item (click)="editarNatureza(item.idNaturezaOperacao)">Editar</button>
                    <button mat-menu-item (click)="duplicarNatureza(item.idNaturezaOperacao)">Duplicar</button>
                    <button mat-menu-item (click)="abrirTornarPadrao(item)" [disabled]="!item.isAtivo" [matTooltip]="!item.isAtivo ? 'Apenas naturezas ativas podem ser definidas como padrão.' : ''">Definir como padrão</button>
                    <button mat-menu-item (click)="alternarStatus(item)" [disabled]="item.isAtivo && item.tiposPadrao.length > 0" [matTooltip]="(item.isAtivo && item.tiposPadrao.length > 0) ? 'Não é possível inativar uma natureza de operação padrão.' : ''">{{ item.isAtivo ? 'Inativar' : 'Ativar' }}</button>
                    <button mat-menu-item (click)="confirmarExclusao(item)" [disabled]="item.tiposPadrao.length > 0" [matTooltip]="item.tiposPadrao.length > 0 ? 'Não é possível excluir uma natureza de operação padrão.' : ''">Excluir</button>
                </mat-menu>
            </div>
            <div class="card-body-mobile p-3">
                <p class="mb-1">
                    <strong>Tipo:</strong>
                    <span class="status-badge ms-1"
                        [class.badge-azul]="item.idTipoOperacao === TipoOperacaoEnum.Entrada"
                        [class.badge-laranja]="item.idTipoOperacao === TipoOperacaoEnum.Saida">
                        {{tipoLabel[item.idTipoOperacao] || item.idTipoOperacao}}
                    </span>
                </p>
                <p class="mb-1"><strong>Regime Tributário:</strong> <span class="status-badge badge-cinza ms-1">{{regimeLabel[item.idRegimeTributario] || item.idRegimeTributario}}</span></p>
                <p class="mb-1"><strong>CFOP:</strong> <span class="status-badge badge-cinza ms-1">{{item.cfopPadrao | mask: '0.000' : { patterns: cfopMaskPatterns } }}</span></p>
                <p class="mb-1 d-flex flex-wrap gap-1 align-items-center">
                    <strong class="me-1">Tributos:</strong>
                    @for (t of item.tributos; track t) {
                    <span class="status-badge badge-azul">{{t}}</span>
                    }
                </p>
                <p class="mb-1">
                    <strong>Reforma Tributária:</strong>
                    @if (item.reformaTributariaConfigurada === null) {
                    <span class="text-secondary ms-1" style="font-size:0.82rem;">—</span>
                    } @else if (item.reformaTributariaConfigurada) {
                    <span class="status-badge badge-verde ms-1">Configurada</span>
                    } @else {
                    <span class="status-badge badge-cinza ms-1">Pendente</span>
                    }
                </p>
                <p class="mb-0">
                    <strong>Status:</strong>
                    @if (item.isAtivo) {
                    <span class="status-badge badge-verde ms-1">Ativa</span>
                    } @else {
                    <span class="status-badge badge-vermelho ms-1">Inativa</span>
                    }
                </p>
            </div>
        </div>
        }
    </div>

    <!-- Ver mais -->
    <div class="col-12 text-center mt-4 mb-5">
        <button mat-button class="btn-ver-mais btn-spinner" [class.btn-loading]="_isLoading"
            [disabled]="_isLoading || _allData.length >= _totalRegistros"
            [attr.aria-label]="_isLoading ? 'Carregando mais registros' : 'Ver mais'"
            (click)="proximaPagina()">
            <span class="material-symbols-outlined">expand_more</span>
            Ver Mais
            @if (_isLoading) { <mat-spinner diameter="20"></mat-spinner> }
        </button>
    </div>

    } @else if (_seedPendente) {
    <!-- Sobra quando o seed falha depois de o usuário já ter respondido o regime no modal: o modal
         não reabre nesse caminho (para não insistir num valor recusado). O botão é a retomada, em
         vez de obrigar a recarregar a página. -->
    <app-empty-list [title]="'Catálogo ainda não inicializado'"
        [subTitle]="'Informe o regime tributário da empresa para criar as naturezas de operação.'">
    </app-empty-list>
    <div class="d-flex justify-content-center mb-4">
        <button mat-flat-button class="btn-primary" type="button" [disabled]="_isLoading"
            (click)="informarRegimeTributario()">
            <mat-icon class="material-symbols-outlined">account_balance</mat-icon>
            Informar regime tributário
        </button>
    </div>
    } @else {
    <app-empty-list [title]="'Nenhuma natureza de operação encontrada'"
        [subTitle]="'Ajuste os filtros para visualizar as naturezas cadastradas.'">
    </app-empty-list>
    }
</div>
